import { ContentSuggestionParams } from 'components/Filters/context/SearchBarContext/types';
import { UserSearchFilter } from 'types/generated/graphql';
import { FiltersParams } from 'types/params';

const getFilterParamsToType = (
    params: FiltersParams | ContentSuggestionParams,
) => {
    let type = undefined as UserSearchFilter | undefined;

    switch (params) {
        case FiltersParams.instruments:
            type = UserSearchFilter.Instruments;
            break;
        case FiltersParams.genres:
            type = UserSearchFilter.Genres;
            break;
        case FiltersParams.textsearch:
            type = UserSearchFilter.Textsearch;
            break;
        case FiltersParams.sfxs:
            type = UserSearchFilter.Sfxs;
            break;
        case FiltersParams.tags:
            type = UserSearchFilter.Tags;
            break;
        case ContentSuggestionParams.suggestedlabels:
            type = UserSearchFilter.SuggestedLabel;
            break;
        case ContentSuggestionParams.suggestedpacks:
            type = UserSearchFilter.SuggestedPack;
            break;
    }

    return type;
};

export default getFilterParamsToType;
